import * as angular from "angular";

export class VoterFileConflictService {
    private readonly root: string;
    private readonly $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.root = __env.apiUrl() + "/voterfile/conflict";
    }

    conflicts(data?: any): Promise<object> {
        const id = data && data.id ? "/" + data.id : "";
        return this.$http.get(this.root + id);
    }

    conflict_matches(data?: any): Promise<object> {
        const id = data ? "/" + data.id : "";
        return this.$http.get(this.root + "/matches" + id);
    }

    add_voter(data: any): Promise<object> {
        return this.$http.post(this.root + "/add_voter", data);
    }

    replace_voter(data: any): Promise<object> {
        return this.$http.post(this.root + "/replace_voter", data);
    }

    delete_conflict(data: any): Promise<object> {
        return this.$http.delete(this.root + "/" + data.id, data);
    }

    delete_all_conflicts(data?: any): Promise<object> {
        return this.$http.delete(this.root, data);
    }

    count_conflicts(): Promise<object> {
        return this.$http.get(this.root + "/count");
    }
}

angular
    .module("vcServices")
    .service("VoterFileConflictService", VoterFileConflictService);
